import React from 'react'

interface FieldProps {
  label: React.ReactNode
  htmlFor?: string
  children: React.ReactNode
  className?: string
  labelClassName?: string
}

// A generic labelled form field: a label above its control with consistent spacing. Shared across the
// platform's configuration forms (column config, menus, panels, …).
const Field: React.FC<FieldProps> = ({
  label,
  htmlFor,
  children,
  className = 'px-2.5 pt-4',
  labelClassName = 'inline-block text-sm font-bold mb-2'
}) => (
  <div className={className}>
    <label htmlFor={htmlFor} className={labelClassName}>
      {label}
    </label>
    {children}
  </div>
)

export default Field
